export default {
  "content": "<g clip-path=\"url(#icon_nav_pro_account_svg__a)\"><path fill-rule=\"evenodd\" d=\"M15 6.402c.55 0 1-.48 1-1.07v-.48c0-.4-.21-.76-.54-.94L8.78.202c-.49-.27-1.07-.27-1.57 0L.54 3.912c-.33.18-.54.54-.54.94v.48c0 .59.45 1.07 1 1.07h1v6.4H1c-.55 0-1 .48-1 1.07v1.06c0 .59.45 1.07 1 1.07h14c.55 0 1-.48 1-1.07v-1.06c0-.59-.45-1.07-1-1.07h-1v-6.4h1zm0 7.47v1.06H1v-1.06h14zm-12-1.07v-6.4h2v6.4H3zm3 0v-6.4h4v6.4H6zm5 0v-6.4h2v6.4h-2zm2.02-7.47H1v-.48l6.68-3.7c.2-.11.44-.11.64 0l6.68 3.7v.48h-1.98z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"icon_nav_pro_account_svg__a\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 16 16"
  }
};